//***************** Interfaces *****************//
export interface ICountry {
  code: string;
  name: string;
}

export interface ICommissionTypeFrontEndModel {
  id: CommissionType;
  name: string;
}

export interface IDurationUnit {
  id: DurationUnit;
  name: string;
}

//***************** Enums *****************//
export enum CommissionType {
  FIXED = 1,
  PERCENT = 2,
}

export enum DurationUnit {
  DAYS = 1,
  WEEKS = 2,
  MONTHS = 3,
  YEARS = 4,
  FULL = 5,
}

export enum ColorName {
  ONLINE = "ONLINE",
  ON_CAMPUS = "ON_CAMPUS",
}

//***************** Types *****************//
export type Symbol = "symbol" | "code";

export type TGetBeautifiedDuration = (
  entityName: string,
  durationUnitId: DurationUnit,
  durationAmount?: string | number,
) => string;

export enum WrapperType {
  Span = "span",
  Div = "div",
}

export enum MaskedLevel {
  Low = "low",
  Medium = "medium",
  Hi = "hi",
}
